export class DialectSdkError extends Error {
    constructor(type, title, msg, details) {
        super(msg);
        this.type = type;
        this.title = title;
        this.msg = msg;
        this.details = details;
        this.msg = msg;
        this.type = type;
        this.title = title;
        this.details = details;
    }
}
export class IllegalArgumentError extends DialectSdkError {
    constructor(title, msg, details) {
        super(IllegalArgumentError.name, title, msg, details);
    }
}
export class IllegalStateError extends DialectSdkError {
    constructor(title, msg, details) {
        super(IllegalStateError.name, title, msg, details);
    }
}
export class UnsupportedOperationError extends DialectSdkError {
    constructor(title, msg, details) {
        super(UnsupportedOperationError.name, title, msg, details);
    }
}
export class UnknownError extends DialectSdkError {
    constructor(details, msg) {
        super(UnknownError.name, 'Error', msg !== null && msg !== void 0 ? msg : 'Something went wrong. Please try again later.', details);
    }
}
export class BusinessConstraintViolationError extends DialectSdkError {
    constructor(msg) {
        super(BusinessConstraintViolationError.name, 'Error', msg);
    }
}
export class ResourceAlreadyExistsError extends DialectSdkError {
    constructor(msg) {
        super(ResourceAlreadyExistsError.name, 'Error', msg);
    }
}
export class AuthenticationError extends DialectSdkError {
    constructor(msg) {
        super(AuthenticationError.name, 'Error', msg);
    }
}
export class AuthorizationError extends DialectSdkError {
    constructor(msg) {
        super(AuthorizationError.name, 'Error', msg);
    }
}
export class ResourceNotFoundError extends DialectSdkError {
    constructor(msg) {
        super(ResourceNotFoundError.name, 'Error', msg);
    }
}
export class IdentityError extends DialectSdkError {
}
//# sourceMappingURL=errors.js.map